import * as React from 'react';
import Editor from '@monaco-editor/react';
import Service from '../../../util/Service';
import { Button, Snackbar, Stack } from '@mui/material';

const NodeEndEvent = React.forwardRef((props, ref) => {
    const { item, processo, style } = props;
    const [themeEditor, setThemeEditor] = React.useState('vs-dark');
    const [code, setCode] = React.useState('');
    const [modelo, setModelo] = React.useState('');
    const [open, setOpen] = React.useState(false);

    React.useImperativeHandle(ref, ()=> ({
        childMethod() {
            handleComplete();
          }
    }))

    React.useEffect(()=>{
        console.log( item );
        console.log( processo );
        const task = processo.lstTask.find( t => t.idTask === item.id );
        console.log( task )
        if( task ){
            setCode( task.code)
        }
        buscaCodigo()
    },[])

    function buscaCodigo(){
        
        Service.FETCH("/api/bpmn/buscaCodigoExemplo/camel-direcEndEvent.txt") 
        .then(r => {            
            setModelo(r)
        });
    }

    const handleComplete = () => {
        const dado = {
            idTask: item.id,
            idProcesso: processo.id,            
            taskType: item.type,
            tipo:"camel",
            code: code
        }
        console.log( dado );

        Service.POST("/api/bpmn/salvarTaskDoProcesso", dado).then(resp => {
            setOpen(true);  
        }).catch(error => {
            console.error(error)
        })
    };
    const handleClose = () => {
        setOpen(false)
      };

    return (
        <div style={{width:'100%'}}>
            <Stack spacing={2}>
                <Button variant="outlined"
                    onClick={(e)=> setCode(modelo)}
                >
                    Busca modelo de codigio
                </Button>
            
            {/* <Editor
                value={code}
                onValueChange={t => setCode(t)}
                highlight={code => {
                    // return( tipo === 'shell')?highlight(code, languages.bash):highlight(code, languages.js)
                    return highlight(code, languages.js)
                }}
                padding={10}
                style={{
                    fontFamily: '"Fira code", "Fira Mono", monospace',
                    fontSize: 12,
                    minHeight: '400px'
                }}
            /> */}
            <Editor
                    height={style ? style.height : "75vh"}
                    // height={"90vh"}
                    width={style? style.width: '100%'}
                    defaultLanguage="javascript"
                    theme={themeEditor}
                    value={code}
                    onChange={t => setCode(t)}
                    // onMount={handleEditorDidMount}
                    options={{
                        minimap: {
                            enabled: false,
                        },
                    }}
                />
            </Stack>

            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={open}
                onClose={handleClose}
                message="Salvo com sucesso!"
                />
        </div>
    )
})

export default NodeEndEvent;